var SliderTransition = require("enyo-ui/SliderTransition"),
    dom              = require("enyo/dom"),
    kind             = require("enyo/kind"),
    utils            = require("enyo/utils");

require("enyo-ui");

/**
 * [SliderSlideTransition]{@link enyo-ui.SliderSlideTransition} animates a slide
 * control in a [Slider]{@link enyo-ui.Slider}.
 *
 * When a slide is activating it will slide into view until it covers the entire
 * slideContainer.
 *
 * When a slide is deactivating it will slide out of view until it is completely
 * outside of the slideContainer.
 *
 * @ui
 * @class   enyo-ui.SliderSlideTransition
 * @extends enyo-ui.SliderTransition
 * @public
 */
module.exports = kind(/** @lends  enyo-ui.SliderSlideTransition.prototype */ {

    /**
     * @private
     */
    name: "enyo-ui.SliderSlideTransition",

    /**
     * @private
     */
    kind: SliderTransition,

    /**
     * The width of the slideContainer.
     *
     * @type    {number}
     * @default 0
     * @public
     */
    containerWidth: 0,

    /**
     * The height of the slideContainer.
     *
     * @type    {number}
     * @default 0
     * @public
     */
    containerHeight: 0,

    /**
     * Start the transition.
     *
     * @private
     */
    start: kind.inherit(function(sup) {
        return function() {
            !this.animating && this.slide.applyStyle("will-change", "transform");
            sup.apply(this, arguments);
        };
    }),

    /**
     * Stop the transition
     *
     * @public
     */
    stop: kind.inherit(function(sup) {
        return function() {
            this.animating && this.slide.applyStyle("will-change", "auto");
            sup.apply(this, arguments);
        };
    }),

    /**
     * Maps the transition value to a css transform, offsetting the slide from
     * the top-left corner of the slideContainer. The [slider
     * axis]{@link enyo-ui.Slider#axis} determines if the slide gets moved
     * horizontally or vertically.
     *
     *  * A transition value of `0` aligns the slide in the top-left corner of
     *    the container.
     *  * A transition value of `1` aligns the slide completely outside the
     *    container on the bottom/right.
     *  * A transition value of `-1` aligns the slide completely outside the
     *    container on the top/left.
     *
     * Slides will also be explicitly shown when partly overlapping the
     * container and explicitly hidden once they have been have completely left
     * the view.
     *
     *
     * @private
     */
    apply: function() {
        var slider     = this.slider,
            slide      = this.slide,
            transforms = slide.domTransforms || {},
            translate  = {},
            progress   = this.animation.scalar.value,
            target     = this.animation.attractors.target.value;

        // Set slide position
        if (slider.accelerate) {
            translate.translateZ = "0";
        }

        if (slider.axis === "horizontal") {
            translate.translateX = (progress * this.containerWidth) + "px";
            translate.translateY = "0px";
        }
        else {
            translate.translateX = "0px";
            translate.translateY = (progress * this.containerHeight) + "px";
        }

        // Ensure the translation transform will be be evaluated first. This
        // prevents scale transform from interfering with the arrangement.
        delete transforms.translateX;
        delete transforms.translateY;
        delete transforms.translateZ;
        slide.domTransforms = utils.mixin(translate, transforms);
        dom.transformsToDom(slide);

        // If slide has moved more than halfway into active position, it's
        // active.
        if (Math.abs(progress) < 0.5 && target === 0) {
            slider.set("activeSlide", slide);
        }
    }

});
